
 

document.addEventListener('DOMContentLoaded',function(){

// add class to the main wrapper
const maincontent_el = document.querySelector('#MainContent');
  
       if (currenttemplate == "product" || currenttemplate == 'index') {
        maincontent_el.classList.remove("page_content_pushleft");
       }
    

const icon_ham = document.querySelector('.ch-ham-icon');
  const icon_cross = document.querySelector('.ch-close-icon');
  const mobile_header_cross_icon = document.querySelector('.mobile-header-cross-icon')
const menu = document.querySelector('.c-header-menu-sidebar');
  const masonrygird = document.querySelector('.main-site-wraper')
  const custom_header_wrapper = document.querySelector('.custom-header-wrapper');

icon_ham.addEventListener('click', function() {
  console.log('icon hame clicked')
  menu.classList.remove('hidden');
  icon_cross.classList.remove('hidden')
  if(mobile_header_cross_icon)
  {
      mobile_header_cross_icon.classList.remove('hidden')

  }
  // icon_ham.classList.add('hidden')
  if(currenttemplate == 'collection')
    {
       localStorage.setItem("collectionMenuState", "open");
    }
  maincontent_el.classList.add('page_content_pushleft');

  if(custom_header_wrapper)
  {
    custom_header_wrapper.classList.add('menu-open')
  }
});

  if(icon_cross){
    console.log('checking the cros icon')
  icon_cross.addEventListener('click', function() {
    console.log('icon cross clicked')
     menu.classList.add('hidden');
    icon_cross.classList.add('hidden')
    if(currenttemplate == 'collection')
    {
       localStorage.setItem("collectionMenuState", "closed");
    }
    
     if(masonrygird)
  {
    masonrygird.classList.add('sidebar_closed');
    masonrygird.classList.remove('sidebar_opened')
  }
    if(custom_header_wrapper)
  {
    custom_header_wrapper.classList.remove('menu-open')
  }
    
  maincontent_el.classList.remove('page_content_pushleft')
 
});
  }

   if(mobile_header_cross_icon){
    console.log('checking the cros icon')
  mobile_header_cross_icon.addEventListener('click', function() {
    console.log('icon cross clicked')
     menu.classList.add('hidden');
    mobile_header_cross_icon.classList.add('hidden')
    if(currenttemplate == 'collection')
    {
       localStorage.setItem("collectionMenuState", "closed");
    }
    
     if(masonrygird)
  {
    masonrygird.classList.add('sidebar_closed');
    masonrygird.classList.remove('sidebar_opened')
  }
    if(custom_header_wrapper)
  {
    custom_header_wrapper.classList.remove('menu-open')
  }
    
  maincontent_el.classList.remove('page_content_pushleft')
 
});
  }


  // header icon 


  // single image banner 
 const banner = document.querySelector(".single-image-banner");

    if (!banner) return; // Exit if the banner is not found

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.boundingClientRect.top > 0 && entry.isIntersecting) {
                document.body.classList.add("banner-in-view");
            } else {
                document.body.classList.remove("banner-in-view");
            }
        },
        { threshold: 0.1 } // Adjust threshold as needed
    );

    observer.observe(banner);





// collection page variant picker
  console.log('why not running')
    const allCustomVariantPickers = document.querySelectorAll('.custom-variant-value');
  console.log('all custom variant',allCustomVariantPickers)
  allCustomVariantPickers.forEach((item) => {
    item.addEventListener('click', function() {
      console.log('item clicked')
      const productUrl = item.getAttribute('data-product-url');
      const variantId = item.getAttribute('data-custom-variant-id');

      if (productUrl && variantId) {
        location.href = productUrl + "?variant=" + variantId;
      }
    });
  });




})
